<div class="main__void">
  <span class="main__void--icon">
    <span class="glicon-itinerary-translate"></span>
  </span>
  <span class="main__void--title">{{ 'itineraries.noItinerariesTranslateTitle' | translate }}</span>
  <span class="main__void--subtitle">{{ 'itineraries.noItinerariesTranslateText' | translate }}</span>
  <gl-button color-primary [text]="'actions.addLanguage' | translate" (onClick)="onCreate()"></gl-button>
</div>
